const defaultState = {
  patient: [],
  count: 0,
  assessment_count: 0,
  valid_patients_count: 0,
  // message : "",
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'PATIENTS':
      const patientData = action.payload || {}; // Ensure action.payload is an object
      const patient = patientData.patients || [];
      const count = patientData.total_patients || 0;
      const assessment_count = patientData.assessment_count || 0;
      const valid_patients_count = patientData.valid_patients_count || 0;
      const completed_patients = patientData.completed_patients || 0

      // Handle other cases here

      return {
        ...state,
        patient,
        count,
        assessment_count,
        valid_patients_count,
        completed_patients
      };

    default:
      return defaultState;
  }
};
